export const ACTIVATE_LOADING_STATUS             = 'ACTIVATE_LOADING_STATUS';
export const DEACTIVATE_LOADING_STATUS           = 'DEACTIVATE_LOADING_STATUS';

export const CHANGE_UI_DISPLAY_LANGUAGE          = 'CHANGE_UI_DISPLAY_LANGUAGE';
